import { isPatron, scrollToTop } from "util";

import classNames from "classnames";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, ScrollRestoration, useLocation, useNavigate } from "react-router-dom";

//import Ad from './Ad'

import AlertDismissible from "components/AlertDismissable";
import GoogleAnalytics from "components/GoogleAnalytics";
import AlternateArtModal from "components/Modals/AlternateArtModal";
import ScrollToTopButton from "components/ScrollToTopButton";
import Toasts from "components/Toasts";
import { initRegion } from "store/auth";
import { fetchMisc } from "store/misc";
import { initRegion as initRegionLocal } from "store/settings";

import Footer from "./Footer";
import styles from "./Layout.module.scss";
import Leaderboard from "./Leaderboard";
import Navbar from "./Navbar";

const Layout = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.firebase.profile);
  const settings = useSelector((state) => state.settings);
  const location = useLocation();
  const history = useNavigate();
  const [prevLocation, setPrevLocation] = useState(location);

  useEffect(() => {
    dispatch(fetchMisc());
  }, []);

  useEffect(() => {
    if (
      location.pathname !== prevLocation?.pathname ||
      location.search !== prevLocation?.search ||
      location.hash !== prevLocation?.hash
    ) {
      dispatch({ history, location, prevLocation, type: "LOCATION_CHANGE" });
      setPrevLocation(location);
    }
  }, [location]);

  // Region initialization (for region-based price sources)
  // Not really part of the Layout, but needs to run on every page
  useEffect(() => {
    if (!settings.region) {
      dispatch(initRegionLocal());
    }
  }, []);
  useEffect(() => {
    if (!profile.region) {
      dispatch(initRegion());
    }
  }, [profile.isLoaded, profile.region]);

  return (
    <div className={styles.containerOuter}>
      <div className={classNames(styles.container, styles.background)}>
        <AlternateArtModal />
        <GoogleAnalytics />
        <ScrollRestoration />
        <ScrollToTopButton />
        <Toasts />
        <Navbar />
        <div className={styles.containerInner}>
          {isPatron(profile) || (
            <>
              <Leaderboard />
              <Helmet>
                <script
                  type="text/javascript"
                  async="async"
                  data-noptimize="1"
                  data-cfasync="false"
                  src="//scripts.mediavine.com/tags/edhrec.js"
                ></script>
              </Helmet>
            </>
          )}
          <AlertDismissible />
          <div className={classNames(styles.background)}>
            <div className={styles.layout}>
              <div className={styles.left}>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
